import { connect } from 'react-redux'
import { toggleDrawer, toggleAppbarWhiteFont, getEnumeration, setLoading, setNotLoading, createKyc,
    updateKyc, deleteKyc, postKYCsSearch, postKYCsSearchAfter, clearKYCsSearch, setOrgState,
    screenPrimaryOwner, screenBeneficialOwner, clearAmlResults, setAmlResults } from '../actions'
import KnowYourCustomer from '../components/KnowYourCustomer'

const mapStateToProps = state => ({
    openDrawer: state.navDrawers.isOpen,
    organization: state.organizations.organization,
    isLoading: (state.kyc && state.kyc.isLoading) || false,
    kyc_nextToken: (state.kyc && state.kyc.kyc_nextToken) || null,
    currentUser: (state.users && state.users.user) || {},
    countries: (state.misc && state.misc.enum && state.misc.enum.country) || [],
    currencies: (state.misc && state.misc.enum && state.misc.enum.currency) || [],
    mcc: (state.misc && state.misc.enum && state.misc.enum.mcc) || [],
    environment: (state.appstate && state.appstate.environment) || 'staging',
    allKycs: (state.kyc && state.kyc.allKycs) || [],
    totalHitsKYCs: (state.kyc && state.kyc.totalHitsKYCs) || 0,
    amlState: state.aml || {},
    amlIsLoading: state.aml?.isLoading || false,
    amlError: state.aml?.error || null,
})

const mapDispatchToProps = dispatch => ({
    toggleDrawer: () => dispatch(toggleDrawer()),
    toggleAppbarWhiteFont: (isWhite) => dispatch(toggleAppbarWhiteFont(isWhite)),
    getEnumeration: (params) => dispatch(getEnumeration(params)),
    setLoading: () => dispatch(setLoading()),
    setNotLoading: () => dispatch(setNotLoading()),
    createKyc: (params, reqBody) => dispatch(createKyc(params, reqBody)),
    updateKyc: (params, reqBody) => dispatch(updateKyc(params, reqBody)),
    deleteKyc: (params) => dispatch(deleteKyc(params)),
    postKYCsSearch: (reqBody) => dispatch(postKYCsSearch(reqBody)),
    postKYCsSearchAfter: (reqBody) => dispatch(postKYCsSearchAfter(reqBody)),
    clearKYCsSearch: () => dispatch(clearKYCsSearch()),
    setOrgState: (reqBody) => dispatch(setOrgState(reqBody)),
    screenPrimaryOwner: (personData) => dispatch(screenPrimaryOwner(personData)),
    screenBeneficialOwner: (personData, ownerIndex) => dispatch(screenBeneficialOwner(personData, ownerIndex)),
    clearAmlResults: () => dispatch(clearAmlResults()),
    setAmlResults: (data) => dispatch(setAmlResults(data))
})

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(KnowYourCustomer)